<div class="bg-th-yellow mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i
      class="fa fa-arrow-left text-secondary my-auto pointer text-dark"
      [routerLink]="['/']"
    ></i>
    <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
      <span class="fw-bold"> پیش ثبت‌نام شیلات </span>
    </a>
  </div>
</div>

<main class="px-2">
  <!-- فیلتر -->
  <div [formGroup]="mdl_Search" class="container-fluid row gx-0 gy-0 mt-3">
    <!-- تاریخ نصب از -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> تاریخ نصب از </label>

        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="false"
          [dateFormat]="'jYYYY/jMM/jDD'"
        >
          <input
            type="text"
            formControlName="strSInstallDate"
            class="form-control text-end"
          />
        </ng-persian-datepicker>
      </div>
    </div>

    <!-- تا تاریخ نصب -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> تا تاریخ نصب </label>

        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="false"
          [dateFormat]="'jYYYY/jMM/jDD'"
        >
          <input
            type="text"
            formControlName="strEInstallDate"
            class="form-control text-end"
          />
        </ng-persian-datepicker>
      </div>
    </div>

    <!-- تاریخ ثبت نام از -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> تاریخ ثبت نام از </label>

        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="false"
          [dateFormat]="'jYYYY/jMM/jDD'"
        >
          <input
            type="text"
            formControlName="strSRegisterDate"
            class="form-control text-end"
          />
        </ng-persian-datepicker>
      </div>
    </div>

    <!-- تا تاریخ ثبت نام -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> تا تاریخ ثبت نام </label>

        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="false"
          [dateFormat]="'jYYYY/jMM/jDD'"
        >
          <input
            type="text"
            formControlName="strERegisterDate"
            class="form-control text-end"
          />
        </ng-persian-datepicker>
      </div>
    </div>

    <!-- استان -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> استان </label>

        <select
          class="form-select p-2"
          formControlName="strState"
          (change)="getCity($event.target.value)"
        >
          <option class="text-center" value="">انتخاب کنید</option>

          <option
            *ngFor="let s of lst_State"
            [value]="s.strState"
            class="text-center"
          >
            {{ s.strStateName }}
          </option>
        </select>
      </div>
    </div>

    <!-- شهر -->
    <ng-container *ngIf="mdl_Search.get('strState')?.value != ''">
      <div class="col-12 col-md-2">
        <div class="position-relative w-100 h-100 p-2">
          <label class="mb-2 text-muted"> شهر </label>

          <select class="form-select p-2" formControlName="strCity">
            <option class="text-center" value="">انتخاب کنید</option>

            <option
              *ngFor="let c of lst_City"
              [value]="c.strCity"
              class="text-center"
            >
              {{ c.strCityName }}
            </option>
          </select>
        </div>
      </div>
    </ng-container>

    <!-- وضعیت -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> وضعیت </label>

        <select class="form-select p-2" formControlName="tiInstallationStatus">
          <option class="text-center" value="-1">انتخاب کنید</option>

          <option
            *ngFor="let Is of lst_Installation_Status"
            [value]="Is.tiInstallationStatus"
            class="text-center"
          >
            {{ Is.strInstallationStatus }}
          </option>
        </select>
      </div>
    </div>

    <!-- نصاب -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> نصاب </label>

        <select class="form-select p-2" formControlName="iInstaller">
          <option class="text-center" value="-1">انتخاب کنید</option>

          <option
            *ngFor="let i of lst_Installer"
            [value]="i.iInstaller"
            class="text-center"
          >
            {{ i.strFullName }}
          </option>
        </select>
      </div>
    </div>

    <!-- بازاریاب -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> بازاریاب </label>

        <select class="form-select p-2" formControlName="iSystemUser_Visitor">
          <option class="text-center" value="-1">انتخاب کنید</option>

          <option
            *ngFor="let i of lst_Visitor"
            [value]="i.iSystemUser"
            class="text-center"
          >
            {{ i.strFullName }}
          </option>
        </select>
      </div>
    </div>

    <!-- موبایل -->
    <div class="col-12 col-md-2">
      <div class="position-relative w-100 h-100 p-2">
        <label class="mb-2 text-muted"> موبایل </label>

        <input
          type="text"
          class="form-control p-2 text-end"
          formControlName="strMobile"
        />
      </div>
    </div>

    <!-- جستجو -->
    <div class="col-12 col-md-auto position-relative p-md-2">
      <button class="w-100 btn btn-primary" (click)="getList()">
        &nbsp; جستجو &nbsp;
      </button>
    </div>

    <!-- منو -->
    <div class="col-12 col-md-auto position-relative p-md-2">
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-outline-secondary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          &nbsp; عملیات ها &nbsp;
        </button>

        <div class="dropdown-menu p-2" style="width: 200px">
          <a
            class="dropdown-item border-bottom p-2 pointer"
            (click)="setSchedule()"
          >
            تعیین زمان نصب
          </a>

          <a
            class="dropdown-item border-bottom p-2 pointer"
            (click)="chooseInstaller()"
          >
            تعیین نصاب
          </a>

          <a
            class="dropdown-item border-bottom p-2 pointer"
            (click)="open_UpdateStatus()"
          >
            تغییر وضعیت
          </a>

          <a
            class="dropdown-item border-bottom p-2 pointer"
            (click)="open_Send_SMS()"
          >
            پیامک به متقاضی
          </a>

          <a
            class="dropdown-item border-bottom p-2 pointer"
            (click)="open_Send_SMSInstaller()"
          >
            پیامک به نصاب</a
          >

          <a
            class="dropdown-item border-bottom p-2 pointer"
            (click)="sendPaymentLink()"
          >
            پیامک لینک پرداخت
          </a>
        </div>
      </div>
    </div>

    <!-- محل های نصب -->
    <div class="col-12 col-md-auto position-relative p-md-2">
      <button class="w-100 btn btn-secondary" (click)="showCluster()">
        &nbsp; محل های نصب &nbsp;
      </button>
    </div>

    <!-- خروجی اکسل -->
    <div class="col-12 col-md-auto position-relative p-md-2">
      <button
        class="w-100 btn btn-success"
        (click)="exportexcel('Export_Excel')"
      >
        &nbsp; خروجی اکسل &nbsp;
      </button>
    </div>
  </div>

  <!-- جدول اطلاعات -->
  <div class="border border-2 container-fluid row gx-0 gy-2 mt-3 p-2">
    <!-- جستجو -->
    <div class="col-12">
      <input
        type="text"
        class="w-100 form-control"
        placeholder="جستجو کنید ..."
        (input)="filter_Result($event.target)"
      />
    </div>

    <!-- جدول اطلاعات -->
    <div class="section border border-2 mt-2">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col" class="">#</th>
            <th scope="col" class="pointer" (click)="selectAllCheckBox()">
              انتخاب
            </th>
            <th scope="col" class="">عملیات</th>
            <th scope="col" class="">وضعیت</th>
            <th scope="col" class="">استان</th>
            <th scope="col" class="">شهر</th>
            <th scope="col" class="pointer">نام و نام خانوادگی</th>
            <th scope="col" class="pointer">موبایل</th>
            <th scope="col" class="pointer">تاریخ ثبت نام</th>
            <th scope="col" class="pointer">تاریخ اعلامی</th>
            <th scope="col" class="pointer">تاریخ نصب</th>
            <th scope="col" class="pointer">نصاب</th>
            <th scope="col" class="pointer">شماره پیگیری پرداخت</th>
            <th scope="col" class="pointer">پرداخت قسطی</th>
            <th scope="col" class="pointer">جمع پرداخت(ریال)</th>
            <th scope="col" class="pointer">بدهکاری(ریال)</th>
            <th scope="col" class="pointer">{{ "برق 12/24" | faNum }}</th>
            <th scope="col" class="pointer">بازاریاب</th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="f14 text-center"
            *ngFor="let item of lst_Result; let i = index"
          >
            <th class="text-dark">{{ i + 1 | faNum }}</th>

            <th class="">
              <input
                type="checkbox"
                (change)="setCheckBox($event.target.checked, item)"
                [checked]="isSelected(item.iPreregistration)"
              />
            </th>

            <th class="">
              <i
                class="fa fa-info-circle fa-lg text-dark pointer me-2"
                (click)="open_Info(item, i)"
              ></i>

              <ng-container
                *ngIf="accessibility('bFleetYar_Advance_PreregistrationEdit')"
              >
                <i
                  class="fa fa-edit fa-lg text-dark pointer me-2"
                  (click)="open_Edit(item, i)"
                ></i>
              </ng-container>
            </th>

            <td>{{ item.strInstallationStatus | faNum }}</td>

            <td>{{ item.strStateName | faNum }}</td>

            <td>{{ item.strCityName | faNum }}</td>

            <td>{{ item.strName + " " + item.strFamily | faNum }}</td>

            <td>{{ item.strMobile | faNum }}</td>

            <td dir="ltr">{{ item?.strRegisterDateTime | faNum }}</td>

            <td dir="ltr">{{ item?.strAnnouncementTime | faNum }}</td>

            <td dir="ltr">{{ item?.strInstallDate | faNum }}</td>

            <td class="">{{ item?.strFullName }}</td>

            <td class="">{{ item?.iTrackingCode | faNum }}</td>

            <td class="">{{ item?.bInstallment ? "✅" : "❌" }}</td>

            <td class="">{{ item?.iPayment | number | faNum }}</td>

            <td class="">{{ item?.iDebit | number | faNum }}</td>

            <td class="">{{ item?.bHas12DC ? "✅" : "❌" }}</td>

            <td class="">{{ item?.strSystemUser_strFullName }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="col-12 text-center table-total-row bg-blue-light">
            <td colspan="1">سرجمع</td>
            <td colspan="13"></td>
            <td>{{ totalIPayment | number | faNum }}</td>
            <td>{{ totalIDebit | number | faNum }}</td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- تعیین زمان نصب -->

  <div class="modal fade" id="schedule_Modal">
    <div class="modal-dialog">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">تعیین زمان نصب</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="mdl_Schedule"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- تاریخ -->

            <div class="col-12 col-md-6 position-relative">
              <label style="top: -8px"> تاریخ </label>

              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strInstallDate"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- ساعت -->

            <div class="col-12 col-md-6 clockpicker position-relative">
              <label style="top: -8px"> ساعت </label>

              <input
                id="strInstallTime"
                formControlName="strInstallTime"
                class="form-control text-center"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submit_Schedule()">
            ثبت اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- تعیین نصاب -->

  <div class="modal fade" id="installer_Modal">
    <div class="modal-dialog">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">تعیین نصاب</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="mdl_Select_Installer"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- نصاب -->

            <div class="col-12">
              <div class="position-relative w-100 h-100">
                <label style="top: -8px; z-index: 2; z-index: 10000">
                  نصاب
                </label>

                <ng-select
                  class="ng-select"
                  [items]="lst_Installer"
                  bindLabel="strFullName"
                  bindValue="iInstaller"
                  [clearable]="true"
                  [placeholder]="'جستجو کنید ...'"
                  [notFoundText]="'موردی یافت نشد'"
                  formControlName="iInstaller"
                >
                  <ng-template
                    ng-multi-label-tmp
                    let-items="items"
                    let-clear="clear"
                  >
                    <div
                      *ngFor="let item of items | slice: 0 : 1"
                      class="ng-value"
                    >
                      <span class="ng-value-label">{{ item.strFullName }}</span>

                      <span
                        class="ng-value-icon right"
                        (click)="clear(item)"
                        aria-hidden="true"
                        >×</span
                      >
                    </div>

                    <div *ngIf="items.length > 1" class="ng-value">
                      <span class="ng-value-label">
                        {{ items.length - 1 | faNum }}+ مورد
                      </span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submit_Installer()">
            ثبت اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- تغییر وضعیت -->

  <div class="modal fade" id="status_Modal">
    <div class="modal-dialog">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">تغییر وضعیت</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="mdl_Status"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- وضعیت -->

            <div class="col-12">
              <div class="position-relative w-100 h-100">
                <label style="top: -8px; z-index: 2; z-index: 10000">
                  وضعیت
                </label>

                <ng-select
                  class="custom"
                  [items]="lst_Status"
                  bindLabel="strInstallationStatus"
                  bindValue="tiInstallationStatus"
                  [clearable]="true"
                  [placeholder]="'جستجو کنید ...'"
                  [notFoundText]="'موردی یافت نشد'"
                  formControlName="tiInstallationStatus"
                >
                  <ng-template
                    ng-multi-label-tmp
                    let-items="items"
                    let-clear="clear"
                  >
                    <div
                      *ngFor="let item of items | slice: 0 : 1"
                      class="ng-value"
                    >
                      <span class="ng-value-label">{{
                        item.strInstallationStatus
                      }}</span>

                      <span
                        class="ng-value-icon right"
                        (click)="clear(item)"
                        aria-hidden="true"
                        >×</span
                      >
                    </div>

                    <div *ngIf="items.length > 1" class="ng-value">
                      <span class="ng-value-label">
                        {{ items.length - 1 | faNum }}+ مورد
                      </span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submit_Status()">
            ثبت اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- پیامک به متقاضی -->

  <div class="modal fade" id="sendSms_Modal">
    <div class="modal-dialog">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">پیامک به متقاضی</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div [formGroup]="mdl_SMS" class="container-fluid row gx-2 gy-2 p-2">
            <!-- متن پیامک -->

            <div class="col-12">
              <div class="position-relative w-100 h-100 p-2">
                <label class="mb-2 text-muted"> متن پیامک </label>

                <textarea
                  style="height: 100px; resize: none"
                  formControlName="strSMS"
                  class="form-control"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submit_Sms()">
            ثبت اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- پیامک به نصاب -->

  <div class="modal fade" id="sendSmsInstaller_Modal">
    <div class="modal-dialog">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">پیامک به نصاب</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="mdl_SMS_Installer"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- متن پیامک -->

            <div class="col-12">
              <div class="position-relative w-100 h-100 p-2">
                <label class="mb-2 text-muted"> متن پیامک </label>

                <textarea
                  style="height: 100px; resize: none"
                  formControlName="strSMS"
                  class="form-control"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submit_SmsInstaller()">
            ثبت اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- جزئیات درخواست -->

  <div class="modal fade" id="requestInfo_Modal" style="z-index: 1054">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">جزئیات درخواست</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="mdl_Request"
            class="container-fluid row gx-2 gy-3 p-2"
          >
            <!-- نام و نام خانوادگی -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> نام و نام خانوادگی </label>

              <input
                formControlName="strFamily"
                class="form-control text-center"
              />
            </div>

            <!-- موبایل -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> موبایل </label>

              <input
                formControlName="strMobile"
                class="form-control text-center"
              />
            </div>

            <!-- کد ملی -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> کد ملی </label>

              <input formControlName="strID" class="form-control text-center" />
            </div>

            <!-- استان -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> استان </label>

              <input
                formControlName="strStateName"
                class="form-control text-center"
              />
            </div>

            <!-- شهر -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> شهر </label>

              <input
                formControlName="strCityName"
                class="form-control text-center"
              />
            </div>

            <!-- نصاب -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> نصاب </label>

              <input
                formControlName="strInstaller_strFullName"
                class="form-control text-center"
              />
            </div>

            <!-- موبایل نصاب -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> موبایل نصاب </label>

              <input
                formControlName="strMobile1"
                class="form-control text-center"
              />
            </div>

            <!-- نوع شناور -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> نوع شناور </label>

              <input
                formControlName="strFloatingType"
                class="form-control text-center"
              />
            </div>

            <!-- شماره پروانه صیادی -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> شماره پروانه صیادی </label>

              <input
                formControlName="strLicenseNo"
                class="form-control text-center"
              />
            </div>

            <!-- وضعیت -->

            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> وضعیت </label>

              <input
                formControlName="strInstallationStatus"
                class="form-control text-center"
              />
            </div>

            <!-- قیمت(ریال) -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> قیمت(ریال) </label>
              <input formControlName="iCost" class="form-control text-center" />
            </div>

            <!-- پرداختی(ریال) -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> پرداختی(ریال) </label>
              <input
                formControlName="iPayment"
                class="form-control text-center"
              />
            </div>

            <!-- بدهکاری(ریال) -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> بدهکاری(ریال) </label>
              <input
                formControlName="iDebit"
                class="form-control text-center"
              />
            </div>

            <!-- شناسه پرداخت  -->

            <ng-container *ngIf="mdl_Request.get('iTrackingCode')?.value > 0">
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> شناسه پرداخت </label>

                <input
                  formControlName="iTrackingCode"
                  class="form-control text-center"
                />
              </div>
            </ng-container>

            <!-- توضیحات -->

            <div
              *ngIf="mdl_Request.get('strComment')?.value"
              class="col-12 position-relative"
            >
              <label style="top: -8px"> توضیحات </label>

              <textarea
                style="min-height: 50px; resize: none"
                formControlName="strComment"
                class="form-control"
              ></textarea>
            </div>

            <!-- توضیحات نصاب -->
            <div
              *ngIf="mdl_Request.get('strInstallerComment')?.value"
              class="col-12 position-relative"
            >
              <label style="top: -8px"> توضیحات نصاب </label>

              <textarea
                style="min-height: 50px; resize: none"
                formControlName="strInstallerComment"
                class="form-control"
              ></textarea>
            </div>

            <!-- پرداخت اقساطی -->
            <ng-container *ngIf="mdl_Request.get('bInstallment')?.value">
              <!-- پرداخت اقساطی -->
              <div
                class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2"
              >
                <input
                  class="form-check-input m-0"
                  type="checkbox"
                  id="bInstallment"
                  formControlName="bInstallment"
                />

                <label
                  class="form-check-label pointer text-muted me-2"
                  for="bInstallment"
                >
                  پرداخت اقساطی
                </label>
              </div>
              <!-- پرداختی اول(ریال) -->
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> پرداختی اول(ریال) </label>
                <input
                  formControlName="iPayment1"
                  class="form-control text-center"
                />
              </div>
              <!-- پرداختی دوم(ریال) -->
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> پرداختی دوم(ریال) </label>
                <input
                  formControlName="iPayment2"
                  class="form-control text-center"
                />
              </div>
              <!-- پرداختی سوم(ریال) -->
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> پرداختی سوم(ریال) </label>
                <input
                  formControlName="iPayment3"
                  class="form-control text-center"
                />
              </div>
            </ng-container>
          </div>

          <div class="container-fluid row gx-2 gy-3 p-2">
            <!-- تغییر وضعیت -->

            <div class="col-12 col-md-auto">
              <div class="w-100 h-100">
                <button class="btn btn-warning" (click)="open_UpdateStatus()">
                  تغییر وضعیت
                </button>
              </div>
            </div>

            <!-- تعیین زمان نصب -->

            <div class="col-12 col-md-auto">
              <div class="w-100 h-100">
                <button class="btn btn-primary" (click)="setSchedule()">
                  تعیین زمان نصب
                </button>
              </div>
            </div>

            <!-- تعیین نصاب -->

            <div class="col-12 col-md-auto">
              <div class="w-100 h-100">
                <button
                  class="btn btn-outline-primary"
                  (click)="chooseInstaller()"
                >
                  تعیین نصاب
                </button>
              </div>
            </div>

            <!-- اقدامات بیشتر -->

            <div class="col-12 col-md-auto">
              <div class="w-100 h-100">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-outline-secondary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    &nbsp; اقدامات بیشتر &nbsp;
                  </button>

                  <div class="dropdown-menu p-2" style="width: 200px">
                    <a
                      class="dropdown-item border-bottom p-2 pointer"
                      (click)="open_Send_SMS()"
                    >
                      پیامک به متقاضی
                    </a>

                    <a
                      class="dropdown-item border-bottom p-2 pointer"
                      (click)="open_Send_SMSInstaller()"
                    >
                      پیامک به نصاب
                    </a>

                    <ng-container
                      *ngIf="mdl_Request.get('strLicenseImage')?.value"
                    >
                      <a
                        class="dropdown-item border-bottom p-2 pointer"
                        (click)="viewFullScreen()"
                      >
                        نمایش تصویر مجوز
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ویرایش درخواست -->

  <div class="modal fade" id="editRequest_Modal" style="z-index: 1054">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">ویرایش درخواست</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="mdl_Request"
            class="container-fluid row gx-2 gy-3 p-2"
          >
            <!-- استان -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> استان </label>

              <select
                class="form-select p-2"
                formControlName="strState"
                (change)="getCity($event.target.value)"
              >
                <option class="text-center" value="">انتخاب کنید</option>

                <option
                  *ngFor="let s of lst_State"
                  [value]="s.strState"
                  class="text-center"
                >
                  {{ s.strStateName }}
                </option>
              </select>
            </div>
            <!-- شهر -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> شهر </label>

              <select class="form-select p-2" formControlName="strCity">
                <option class="text-center" value="">انتخاب کنید</option>

                <option
                  *ngFor="let c of lst_City"
                  [value]="c.strCity"
                  class="text-center"
                >
                  {{ c.strCityName }}
                </option>
              </select>
            </div>
            <!-- وضعیت -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> وضعیت </label>

              <select
                class="form-select p-2"
                formControlName="tiInstallationStatus"
              >
                <option
                  *ngFor="let Is of lst_Installation_Status"
                  [value]="Is.tiInstallationStatus"
                  class="text-center"
                >
                  {{ Is.strInstallationStatus }}
                </option>
              </select>
            </div>
            <!-- شناسه پرداخت  -->
            <div class="col-12 col-md-4 position-relative">
              <label style="top: -8px"> شناسه پرداخت </label>

              <input
                formControlName="iTrackingCode"
                class="form-control text-center"
              />
            </div>
            <!-- آدرس -->
            <div class="position-relative col-12 col-md-8">
              <label class="mb-2 text-muted"> آدرس </label>

              <custom-map
                *ngIf="bMapInput"
                [strValue]="mdl_Request.get('strAddress')?.value"
                [longLat]="[
                  mdl_Request.get('fLon')?.value,
                  mdl_Request.get('fLat')?.value,
                ]"
                [stylesArray]="['padding-top: 10px']"
                [isTextArea]="false"
                [isLocationBtn]="true"
                [str_Placeholder]="'آدرس خود را جستجو کنید ...'"
                (mdl_Submit)="submitData($event)"
              >
              </custom-map>
            </div>
            <!-- توضیحات -->
            <div class="col-12 position-relative">
              <label style="top: -8px"> توضیحات </label>

              <textarea
                style="min-height: 50px; resize: none"
                formControlName="strComment"
                class="form-control"
              ></textarea>
            </div>
            <!-- داری برق ۱۲ یا ۲۴ ولت -->
            <div
              class="form-check form-switch m-0 d-flex align-items-center col-12 p-2"
            >
              <input
                class="form-check-input m-0"
                type="checkbox"
                id="bHas12DC"
                formControlName="bHas12DC"
              />

              <label
                class="form-check-label pointer text-muted me-2"
                for="bHas12DC"
              >
                داری برق ۱۲ یا ۲۴ ولت
              </label>
            </div>
            <!-- پرداخت اقساطی -->
            <div
              class="form-check form-switch m-0 d-flex align-items-center col-12 p-2"
            >
              <input
                class="form-check-input m-0"
                type="checkbox"
                id="bInstallment2"
                formControlName="bInstallment"
              />

              <label
                class="form-check-label pointer text-muted me-2"
                for="bInstallment2"
              >
                پرداخت اقساطی
              </label>
            </div>
            <!-- پرداختی‌ها  -->
            <ng-container *ngIf="mdl_Request.get('bInstallment')?.value">
              <!-- توضیحات پرداخت -->
              <div class="col-12 position-relative">
                <label style="top: -8px"> توضیحات پرداخت </label>

                <textarea
                  style="min-height: 50px; resize: none"
                  formControlName="strPaymentComment"
                  class="form-control"
                ></textarea>
              </div>
              <!-- پرداختی اول(ریال) -->
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> پرداختی اول(ریال) </label>
                <input
                  oninput="
                    this.value = this.value
                      .replace(/[^0-9]/g, '')
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  formControlName="iPayment1"
                  class="form-control text-center"
                />
              </div>
              <!-- پرداختی دوم(ریال) -->
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> پرداختی دوم(ریال) </label>
                <input
                  oninput="
                    this.value = this.value
                      .replace(/[^0-9]/g, '')
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  formControlName="iPayment2"
                  class="form-control text-center"
                />
              </div>
              <!-- پرداختی سوم(ریال) -->
              <div class="col-12 col-md-4 position-relative">
                <label style="top: -8px"> پرداختی سوم(ریال) </label>
                <input
                  oninput="
                    this.value = this.value
                      .replace(/[^0-9]/g, '')
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  formControlName="iPayment3"
                  class="form-control text-center"
                />
              </div>
            </ng-container>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-primary" (click)="updateRequest()">
            اعمال تغییرات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
